import { submenuOptions } from './sidebar-submenu.types';
import Settings from '@mui/icons-material/Settings';
import SignOutIcon from '@mui/icons-material/MeetingRoom';

import {
  EmailIcon,
  MenuBookIcon,
  SlackLogoIcon,
  SupportIcon,
} from '@xlrt/components';

export const SUBMENU_OPTIONS: Record<submenuOptions, submenuOptions> = {
  create: 'create',
  support: 'support',
  setting: 'setting',
  none: 'none',
};
export const SUPPORT_SIDEBAR_OPTIONS = [
  {
    icon: () => <MenuBookIcon lightMode={false} />,
    title: 'XELERATE Documentation',
    external: false,
    to: '/catalog/default/component/xelerate/docs',
  },
  {
    icon: () => <SupportIcon lightMode={false} />,
    title: 'Create a support ticket',
    external: true,
    to: 'https://devstack.vwgroup.com/jira/servicedesk/customer/portal/251',
  },
  {
    icon: () => <EmailIcon lightMode={false} />,
    title: 'Contact us via mail',
    external: true,
    to: 'mailto:xelerate@cariad.technology?subject=Support%20XELERATE',
  },
  {
    icon: () => <SlackLogoIcon lightMode={false} />,
    title: 'Reach out in Slack',
    external: true,
    to: 'https://cariad.enterprise.slack.com/archives/C06UA5E3TK8',
  },
];

export const SETTING_SIDEBAR_OPTIONS = [
  {
    icon: () => <Settings />,
    title: 'Settings',
    external: false,
    to: '/settings',
  },
  {
    icon: () => <SignOutIcon />,
    title: 'Sign Out',
    external: false,
    to: 'SIGN_OUT',
  },
];
